<template>
   <section class="units-hero" v-if="hero">
      <div class="content">
         <p class="label grey underline">
            {{ label }}
         </p>
         <h1 class="headline h2">{{ hero?.title }}</h1>
         <h4 v-if="hero?.age_group" class="subheadline serif grey">
            {{ hero.age_group }}
         </h4>
         <h4
            v-if="hero?.section_count || hero?.sections_total_duration"
            class="subheadline serif grey"
         >
            {{ sectionCount }} | {{ formatedTime }}
         </h4>

         <div
            v-if="hero?.description && hasHtmlTags"
            class="desc"
            v-html="hero.description"
         ></div>
         <div v-else="hero?.description && !hasHtmlTags" class="desc">
            <p>{{ hero.description }}</p>
         </div>
         <slot name="actions" />
      </div>
      <Image
         v-if="hero.image?.src"
         class="hero"
         :image="hero.image"
         fit="cover"
      />
   </section>
   <EmptySplitHero v-else />
</template>

<script setup lang="ts">
const { hero } = defineProps({
   hero: Object,
});
// NOTE: this should be built out better to be more dynamic
const label = computed(() => {
   if (hero?.discipline) {
      return `${hero.discipline.title} Sequence`;
   } else {
      return "Professional Development Course";
   }
});

const formatedTime = computed(() => {
   if (hero?.sections_total_duration) {
      return formatTime(hero.sections_total_duration);
   }
});

const sectionCount = computed(() => {
   if (hero?.section_count) {
      return `${hero.section_count} Sections`;
   }
});

const hasHtmlTags = computed(() => {
   if (!hero?.discipline) return false;
   const regex = /<\/?[a-z][\s\S]*>/i;
   return regex.test(hero?.description);
});
</script>

<style lang="scss">
@import "~/assets/scss/globals/split-hero";
</style>
